import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/material';

// Styled components
const Box = styled('div')(({ width, vertical, horizontal }) => ({
  backgroundColor: 'rgba(0, 128, 255, 0.1)',
  border: '1px solid rgba(0, 128, 255, 0.3)',
  color: 'rgba(0, 64, 128, 0.9)',
  borderRadius: '4px',
  display: 'flex',
  alignItems: vertical ? vertical : 'center',
  justifyContent: horizontal ? horizontal : 'flex-start',
  width: width ? width : 'fit-content',
  padding: '8px 12px',
  fontSize: '14px',
}));

/**
 * ExternalWarningBox - Displays a warning box with styling that matches the ExternalTaskChip
 *
 * @param {Object} props
 * @param {string|JSX.Element} props.text - The text or JSX element to display
 * @param {string} props.width - Width of the box ('full-width' or 'fit-content')
 * @param {string} props.vertical - Vertical alignment ('center', 'flex-start', etc.)
 * @param {string} props.horizontal - Horizontal alignment ('center', 'flex-start', etc.)
 * @returns {JSX.Element} The external warning box component
 */
function ExternalWarningBox({ text, width, vertical, horizontal }) {
  return (
    <Box width={width} vertical={vertical} horizontal={horizontal}>
      {text}
    </Box>
  );
}

ExternalWarningBox.propTypes = {
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  width: PropTypes.string,
  vertical: PropTypes.string,
  horizontal: PropTypes.string,
};

export default ExternalWarningBox;
